<div class="row">
  <div class="col-3">
    <div class="col-left p-3 pt-5 p-xl-4 pt-xl-5 purchase-list-aside">
      <h2>{{ 'popins.products_list.title' | translate }}</h2>
      <p class="info">{{ 'popins.products_list.customer_id' | translate }} {{ customerInfos.id }}</p>
      <p class="info">{{ 'popins.products_list.name' | translate }} {{ customerInfos.name }}</p>
      <p class="info">
        {{ 'popins.products_list.project' | translate }}
        {{
          current.HBMProject
            ? current.HBMProject.name
            : ('popins.price_info.placeholder_project_' + customer.context | translate)
        }}
      </p>

      <div class="price-table-container">
        <table class="price-table w-100" *ngIf="beautifiedBom">
          <tbody>
          <tr *ngFor="let productCategory of beautifiedBom.totalByCategories">
            <th>{{ 'popins.products_list.main.' + productCategory.key + '.title' | translate }}</th>
            <td>{{ productCategory.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>{{ 'popins.products_list.aside.total' | translate }}</th>
            <td>{{ beautifiedBom.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th>{{ 'popins.products_list.aside.totalTva' | translate }}</th>
            <td>{{ beautifiedBom.totalPrice * 0.2 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th class="ecofees">{{ 'popins.products_list.aside.totalDeee' | translate }}</th>
            <td class="ecofees">{{ beautifiedBom.totalDeee | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th class="ecofees">{{ 'popins.products_list.aside.totalEcomob' | translate }}</th>
            <td class="ecofees">{{ beautifiedBom.totalEcomob | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="legacy" [innerHtml]="'popins.products_list.aside.disclaimer' | translate"></div>
    </div>
  </div>

  <div class="col-9">
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="modal-content-body">
      <div class="init-text pt-5" *ngIf="beautifiedBom.empty">
        {{ 'popins.products_list.empty' | translate }}
      </div>

      <div class="product-list pr-4 pt-5" *ngIf="!beautifiedBom.empty">
        <table class="table product-table">
          <ng-container *ngFor="let productBlocks of beautifiedBom.blocks">
            <tr class="title-row">
              <td><img width="64" height="64" [src]="productBlocks.thumbnailURLSmall" /></td>
              <td colspan="6" class="text-left">
                <span *ngIf="productBlocks.nomenclatureNumber > 0" class="block-number"
                >M{{ productBlocks.nomenclatureNumber }} - </span
                ><span>{{ productBlocks.title }}</span>
              </td>
              <td class="text-right">{{ productBlocks.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
            </tr>
            <tr class="product-table-label">
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>
                <span>{{ 'popins.products_list.main.columns.ref' | translate }}</span>
              </th>
              <th colspan="2">
                <span>{{ 'popins.products_list.main.columns.name' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.price' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.qty' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.total' | translate }}</span>
              </th>
            </tr>
            <tr *ngFor="let productRow of productBlocks.rows; let last = last" [class.last]="last">
              <td>&nbsp;</td>
              <td><img width="48" height="48" [src]="productRow.thumbnailURLSmall" /></td>
              <td class="ref">
                {{ productRow.reference }}
                <ng-container *ngIf="productRow.pmm"><br />{{ productRow.pmm }}</ng-container>
              </td>
              <td colspan="2">{{ productRow.name }}</td>
              <td>{{ productRow.price.current.value | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              <td>{{ productRow.quantity }}</td>
              <td>
                {{
                  productRow.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                }}<span class="ecofees" *ngIf="productRow.totalDeee > 0"
              ><br />{{ 'popins.products_list.aside.totalDeee' | translate }}
                {{ productRow.totalDeee | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span
              >
                <span class="ecofees" *ngIf="productRow.totalEcomob > 0"
                ><br />{{ 'popins.products_list.aside.totalEcomob' | translate }}
                  {{ productRow.totalEcomob | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span
                >
              </td>
            </tr>

            <tr class="spacer" colspan="8">
              <td>&nbsp;</td>
            </tr>
          </ng-container>
        </table>
      </div>
    </div>

    <div class="footer">
      <div class="text-right">
        <!--<ng-casto-btn class="blue" [disabled]="!projectIsSaved" *ngIf="vendorEnvironment && (quoteSystem == 'LegacyCommerce')" (click)="downloadLegacyCommerceCsv()" label="Télécharger csv"></ng-casto-btn>-->
        <ng-casto-btn
          class="blue"
          [disabled]="!projectIsSaved || isBomEmpty"
          *ngIf="vendorEnvironment"
          (click)="order()"
          label="Continuer"></ng-casto-btn>
        <ng-casto-btn
          class="blue"
          [disabled]="isBomEmpty"
          [loading]="printLoading"
          (click)="printList()"
          label="Imprimer"></ng-casto-btn>
      </div>
    </div>
  </div>
</div>
